module.exports = __webpack_public_path__ + "img/parking.7c4cc63a.svg";